import axios from "axios";
import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_FAIL,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESET_PASSWORD_REQUEST,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_FAIL,
  AUTH_UPDATE_PASSWORD_REQUEST,
  AUTH_UPDATE_PASSWORD_SUCCESS,
  AUTH_UPDATE_PASSWORD_FAIL,
  AUTH_VERIFY_LOGIN_CODE_REQUEST,
  AUTH_VERIFY_LOGIN_CODE_SUCCESS,
  AUTH_VERIFY_LOGIN_CODE_FAIL,
  AUTH_SWITCH_TENANT_REQUEST,
  AUTH_SWITCH_TENANT_SUCCESS,
  AUTH_SWITCH_TENANT_FAIL,
} from "../constants/authConstants";

export const login = (email, password, language) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_LOGIN_REQUEST });
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post(
      "/api/auth/login",
      { email, password, language },
      config
    );
    dispatch({ type: AUTH_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
    return data;
  } catch (error) {
    const errorMessage = error.response?.data.message || error.message;
    dispatch({
      type: AUTH_LOGIN_FAIL,
      payload: errorMessage,
    });
    throw new Error(errorMessage); // Ensure the error is thrown
  }
};

export const googleLogin = (accessToken) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_LOGIN_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post(
      "/api/auth/google",
      { access_token: accessToken },
      config
    );

    // console.log("Google Login Data:", data);

    dispatch({ type: AUTH_LOGIN_SUCCESS, payload: data }); // ✅ use AUTH_LOGIN_SUCCESS
    localStorage.setItem("userInfo", JSON.stringify(data));
    return data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Google authentication failed. Please try again.";

    dispatch({ type: AUTH_LOGIN_FAIL, payload: errorMessage }); // ✅ use AUTH_LOGIN_FAIL
    throw new Error(errorMessage);
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("cartItems");
  localStorage.removeItem("shippingAddress");
  localStorage.removeItem("paymentMethod");
  dispatch({ type: AUTH_LOGOUT });
  document.location.href = "/login";
};

export const logoutNoRedirect = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("cartItems");
  localStorage.removeItem("shippingAddress");
  localStorage.removeItem("paymentMethod");
  dispatch({ type: AUTH_LOGOUT });
};

export const verifyLoginCode = (email, code) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_VERIFY_LOGIN_CODE_REQUEST });
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post(
      "/api/auth/verify-login-code",
      { email, code },
      config
    );
    dispatch({ type: AUTH_VERIFY_LOGIN_CODE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: AUTH_VERIFY_LOGIN_CODE_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

export const switchTenantAction = (slug) => async (dispatch, getState) => {
  try {
    dispatch({ type: AUTH_SWITCH_TENANT_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    const token = userInfo?.token;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Add token to the request
      },
    };

    const { data } = await axios.post(
      "/api/auth/switch-tenant",
      { slug },
      config
    );

    // console.log("Switch Tenant Data:", data);

    // ✅ Dispatch the new token and user info to Redux store
    dispatch({ type: AUTH_SWITCH_TENANT_SUCCESS, payload: data });

    // ✅ Update localStorage with the new token and user info
    localStorage.setItem("userInfo", JSON.stringify(data));

    return data;
  } catch (error) {
    dispatch({
      type: AUTH_SWITCH_TENANT_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// 1. Request reset link (email)
export const requestPasswordResetAction =
  (email, language) => async (dispatch) => {
    try {
      dispatch({ type: AUTH_RESET_PASSWORD_REQUEST });
      const config = { headers: { "Content-Type": "application/json" } };
      const { data } = await axios.post(
        "/api/auth/request-password-reset",
        {
          email,
          language,
        },
        config
      );
      dispatch({ type: AUTH_RESET_PASSWORD_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({
        type: AUTH_RESET_PASSWORD_FAIL,
        payload: error.response?.data.message || error.message,
      });
      throw error;
    }
  };

// 2. Confirm new password
export const resetPasswordConfirmAction =
  (email, token, newPassword, language) => async (dispatch) => {
    try {
      dispatch({ type: AUTH_UPDATE_PASSWORD_REQUEST });
      const { data } = await axios.post("/api/auth/reset-password", {
        email,
        token,
        newPassword,
        language,
      });
      dispatch({ type: AUTH_UPDATE_PASSWORD_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({
        type: AUTH_UPDATE_PASSWORD_FAIL,
        payload: error.response?.data.message || error.message,
      });
      throw error;
    }
  };
